module.exports = __webpack_public_path__ + "img/about1.7bc58578.jpg";